import { env } from './env'

export const VERSION = env('REACT_APP_VERSION') ?? 'local'

/** Whether we're running in a test environment */
export const IS_TEST = [process.env.TEST, process.env.VITEST].includes('true')

/** Whether we're running in a local environment */
export const IS_LOCAL = env('REACT_APP_STAGE') === 'local'

/** @deprecated seems not to be used, should be removed if confirmed */
export const RULE_SOURCE_SEPARATOR = '/'

/** When will the desktop stepper switch into mobile one */
export const STEPPER_DESKTOP_LIMIT = 8

/** Datadog id and client token */
export const DATADOG_APPLICATION_ID = 'df1ff5a4-412d-4da3-b4d6-99b2f797fc41'
export const DATADOG_CLIENT_TOKEN = 'pubcbfbb4b2a92ed722ad8c1e40b2880553'

/**
 * Name of the cookie that indicates whether third-party resources and tracking
 * are allowed.
 *
 * This cookie is set by the Juice App in accordance to Journey settings, when available.
 * If the Journey is not found, cookie is set to `1` by default.
 */
export const THIRD_PARTY_COOKIE_NAME = 'x-epilot-journey-3rd-party'

/**
 * Measures the time spent between the initial execution of the App bundle
 * and the first time the Journey App renders a Step content to the end-user.
 *
 * This is meant to track how much time the user is waiting for that.
 */
export const TIME_TO_FIRST_RENDER_METRIC = 'timeToFirstRender'

/**
 * Measures the time spent between the initial execution of the App bundle
 * and the App becoming **ready** to start rendering the Journey, regardless of the time of
 * the actual first render.
 */
export const TIME_TO_READINESS = 'timeToReadiness'

/**
 * Google Maps API Key.
 * Used throught `@googlemaps/js-api-loader` to embed Google Maps.
 */
export const GOOGLE_MAPS_API_KEY = 'AIzaSyDCbX7jMWETrRawPfO_BpDV_owCv7V2LgM'
